import React from 'react';
export function ResultsClosingCta() {
  return <section className="w-full bg-brand-navy py-12 md:py-14 px-4 sm:px-6 lg:px-8 text-center" data-id="element-228" data-mp="llfnm4b8bojv">
      <div className="max-w-4xl mx-auto" data-id="element-229" data-mp="173h2u3971dob">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-8 leading-tight" data-id="element-230" data-mp="12bgylym3bylx">
          Your team could be next.
        </h2>
        <p className="text-xl md:text-2xl text-gray-300 mb-12 leading-relaxed max-w-3xl mx-auto" data-id="element-231" data-mp="xccon5rcdwuj">
          Book a 30-minute call. We'll look at where your team stands and figure
          out the fastest path forward.
        </p>
        <div className="flex flex-col items-center space-y-6" data-id="element-232" data-mp="oek6ltu8kb3g">
          <a href="#/contact/book" className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-lg font-bold rounded bg-brand-orange text-white hover:bg-brand-orange-hover transition-colors shadow-sm w-full sm:w-auto" data-id="element-233" data-mp="jdmrxr8fpz6p">
            Book a Call
          </a>
          <p className="text-white text-base" data-id="element-234" data-mp="28pygwzsi0eka">
            Or email me directly:{' '}
            <a href="mailto:michael@breakapencil.com" className="text-white border-b-2 border-brand-orange hover:text-brand-orange transition-colors pb-0.5" data-id="element-235" data-mp="3lob3etb78kpr">
              michael@breakapencil.com
            </a>
          </p>
        </div>
      </div>
    </section>;
}